export default "__VITE_ASSET__VKDVwpqs__"